import { useState, useEffect } from "react";
import notify from "./../useNotifaction";
import { useDispatch, useSelector } from "react-redux";
import { createNewUser } from "../../redux/actions/authAction";
import { useNavigate } from "react-router-dom";
import { validateEgyptianPhoneNumber } from "../../Feature/PhoneValidRegex";
import validatePassword from "../../Feature/PassworValidRegex";
import { validateEmail } from "../../Feature/EmailValidRegex";
import { validateName } from "../../Feature/NameValidRegex";

const RegisterHook = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const onChangeName = (e) => {
    setName(e.target.value);
  };
  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };
  const onChangePhone = (e) => {
    setPhone(e.target.value);
  };
  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };
  const onChangeConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };
  const onChangeRememberMe = () => {
    setRememberMe(!rememberMe);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordConFirmVisibility = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };
  const isComplate =
    password.length > 8 &&
    email.length > 8 &&
    !isPress &&
    validateName(name).length === 0 &&
    validateEmail(email).length === 0 &&
    validateEgyptianPhoneNumber(phone).length === 0 &&
    validatePassword(password).length === 0 &&
    validatePassword(confirmPassword).length === 0;

  const res = useSelector((state) => state.authReducer.createUser);

  //save data
  const OnSubmit = async () => {
    setIsPress(true);
    // validationValues();
    setLoading(true);
    await dispatch(
      createNewUser({
        name,
        email,
        password,
        passwordConfirm: confirmPassword,
        phone,
        rememberMe,
      })
    );
    setLoading(false);
    setIsPress(false);
  };

  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
          notify("تم تسجيل الحساب بنجاح", "success");
          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
        }

        if (res.data.errors) {
          if (res.data.errors[0].msg === "E-mail already in use")
            notify("هذا الايميل مسجل من قبل", "error");
        }
        if (res.data.errors) {
          if (res.data.errors[0].msg === "accept only egypt phone numbers")
            notify("يجب ان يكون الرقم مصري مكون من 11 رقم", "error");
        }

        if (res.data.errors) {
          if (res.data.errors[0].msg === "must be at least 6 chars")
            notify("يجب ان لاقل كلمه السر عن 6 احرف او ارقام", "error");
        }
      }
    }
  }, [loading, navigate, res]);

  return [
    name,
    email,
    phone,
    password,
    confirmPassword,
    loading,
    onChangeName,
    onChangeEmail,
    onChangePhone,
    onChangePassword,
    onChangeConfirmPassword,
    OnSubmit,
    isPress,
    rememberMe,
    onChangeRememberMe,
    isComplate,
    showPassword,
    showPasswordConfirm,
    togglePasswordVisibility,
    togglePasswordConFirmVisibility,
  ];
};

export default RegisterHook;
